import React, { useEffect, useState } from "react";
import Axios from "axios";
import "./index.css";
import { CircularProgress } from "@mui/material";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import TextField from "@mui/material/TextField";
import { toast, ToastContainer } from "react-toastify";
import { Avatar } from "@mui/material";
import { Box, Modal, Pagination } from "@mui/material";
import { useNavigate } from "react-router-dom";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  maxWidth: "90%",
  width: "568px",
  borderRadius: "24px",
  bgcolor: "white",
  boxShadow: "2px 2px 8px rgba(83, 83, 83, 0.12)",
  padding: "32px",
};
const EmailLogs = () => {
  const [plans, setPlans] = useState([]);
  const [count, setCount] = useState(0);
  const [page, setPage] = useState(1);
  const [newplantype, setnewplantype] = useState("");
  const [newplanduration, setnewplanduration] = useState("");
  const [sendPlanUpdatedEmail, setsendPlanUpdatedEmail] = useState(true);
  // const [sendReminders, setsendReminders] = useState(true);

  const [sorttype, setsorttype] = useState("decreaseexpiry");
  const [loader, setloader] = useState(false);

  const [startDate, setStartDate] = useState(new Date("Sun Jan 01 2022"));
  const [endDate, setEndDate] = useState(new Date());
  const [searchuser, setsearchuser] = useState("");
  const [fetchedusers, setfetchedusers] = useState([]);
  const [selectedUserId, setselectedUserId] = useState(null);
  const [currentuser, setcurrentuser] = useState(null);
  const fetchPlans = async () => {
    setloader(true);
    await Axios({
      method: "get",
      url: `/api/cronjobs/allemaillogs?&start=${startDate}&end=${endDate}&email=${selectedUserId?.email}&sorttype=${sorttype}&page=${page}&size=20`,
    })
      .then((res) => {
        setPlans(res.data.data);
        setloader(false);
        setCount(res.data.count);
        setsearchuser("");
      })
      .catch((err) => {
        console.log(err);
        setloader(false);
      });
  };
  const fetchUserByName = async () => {
    try {
      // if (searchuser.trim() === "") {
      //   setselectedUserId(null);
      //   setfetchedusers([]);
      //   return;
      // }
      const response = await Axios.get(`/api/admin/searchuser?s=${searchuser}`);
      if (response.data.success) {
        setfetchedusers(response.data.data);
      }
    } catch (error) {
      if (error && error.response && error.response.data) {
        toast.error(error.response.data.error);
      }
    }
  };
  const handleUpdatePlan = async () => {
    try {
      if (!confirm("Are you sure of updating this user's plan?")) return;
      const response = await Axios.post(`/api/admin/updateplan`, {
        newplantype,
        userid: currentuser?._id,
        newplanduration,
        sendPlanUpdatedEmail,
      });
      if (response.data.success) {
        handleclose();
        toast.success("Plan updated successfully");
      }
    } catch (error) {
      if (error && error.response && error.response.data) {
        toast.error(error.response.data.error);
      }
    }
  };
  const navigate = useNavigate();
  useEffect(() => {
    fetchPlans();
  }, [startDate, endDate, selectedUserId, sorttype, page]);
  useEffect(() => {
    if (searchuser?.trim() != "") fetchUserByName();
    else setfetchedusers([]);
  }, [searchuser]);

  const returnDate = (d) => {
    return new Date(d).toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });
  };
  const [open, setopen] = useState(false);
  const handleopen = (u) => {
    setcurrentuser(u);
    setopen(false);
  };
  const handleclose = () => setopen(false);

  return (
    <>
      <ToastContainer />
      <div className="plan_root">
        <div className="d-flex justify-content-between">
          <div className="">
            <div>
              <p>Search User</p>
              <input
                style={{ width: "500px", padding: "8px" }}
                value={searchuser}
                className="h-40px"
                onChange={(e) => setsearchuser(e.target.value)}
                type="text"
                placeholder="Get timeline by name"
              />
            </div>

            <div className="gd_explore_main_results_block">
              <div
                style={{ backgroundColor: "white" }}
                className="gd_explore_main_results"
              >
                {fetchedusers.map((v, i) => (
                  <div
                    key={i}
                    onClick={() => {
                      setselectedUserId(v);
                      setfetchedusers([]);
                    }}
                    className="gd_explore_main_result d-flex justify-content-between align-items-center mb-16 pointer"
                  >
                    <div className="d-flex align-items-center">
                      <Avatar
                        src={v.avatar}
                        alt={v.name ?? v.firstname}
                        style={{ height: 40, width: 40 }}
                      />
                      <div style={{ color: "black" }} className="ml-12">
                        <p className="body1">
                          {v.type === "member"
                            ? `${v.firstname} ${v.lastname},(${v.type}) `
                            : `${v.name}, (${v.firstname} ${v.lastname},${v.type})`}

                          <span className="caption"> {v.email}</span>
                        </p>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>

          <div className="">
            <p htmlFor="typeDropdown">Sort</p>
            <select
              id="typeDropdown"
              className="h-40px"
              value={sorttype}
              onChange={(e) => setsorttype(e.target.value)}
            >
              <option value="decreaseexpiry"> Recently sent</option>
              <option value="increaseexpiry"> Past</option>
            </select>
          </div>
          <div className="">
            <p>Select Timeline</p>
            <div style={{ backgroundColor: "white", width: "100%" }}>
              <LocalizationProvider dateAdapter={AdapterDateFns}>
                <DatePicker
                  style={{ backgroundColor: "white" }}
                  value={startDate}
                  onChange={(newValue) => {
                    setStartDate(newValue);
                  }}
                  sx={{
                    border: "1px solid #ccc",
                    borderRadius: "5px",
                    width: "170px",
                    height: "40px",
                  }}
                  format="dd MMM yyyy"
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      variant="outlined"
                      label="Start Date"
                    />
                  )}
                />
              </LocalizationProvider>
              <LocalizationProvider dateAdapter={AdapterDateFns}>
                <DatePicker
                  value={endDate}
                  onChange={(newValue) => {
                    setEndDate(newValue);
                  }}
                  format="dd MMM yyyy"
                  sx={{
                    border: "1px solid #ccc",
                    borderRadius: "5px",
                    width: "170px",
                    height: "40px",
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      variant="outlined"
                      label="End Date"
                    />
                  )}
                />
              </LocalizationProvider>
            </div>
          </div>
        </div>
        {loader && <CircularProgress />}
        <div className="plan_main">
          {selectedUserId ? (
            <>
              <p
                className="row align-items-center mx-0 mb-0 pointer"
                style={{
                  backgroundColor: "white",
                  color: "black",
                  padding: "8px",
                  width: "50%",
                }}
              >
                <Avatar src={selectedUserId.avatar} />
                &nbsp;
                {`${selectedUserId.firstname} ${selectedUserId.lastname}, (${selectedUserId.name},${selectedUserId.type}) `}
              </p>
              <button
                onClick={() => setselectedUserId(null)}
                style={{ backgroundColor: "red" }}
              >
                X
              </button>
            </>
          ) : (
            ""
          )}
          {plans.length > 0 ? (
            <table className="plan_table mt-24">
              <thead className="plan_thead">
                <tr className="plan_thead_tr plan_tr">
                  <th className="plan_thead_tr plan_td">Email Subject</th>
                  <th className="plan_thead_tr plan_td">Recipient</th>
                  <th className="plan_thead_tr plan_td">Profile</th>
                  <th className="plan_thead_tr plan_td">Sent at</th>
                </tr>
              </thead>
              <tbody className="plan_tbody">
                {plans.map((plan) => (
                  <tr key={plan._id} className="plan_tbody_tr plan_tr">
                    <td
                      onClick={() => handleopen()}
                      className="plan_tbody_td plan_td"
                    >
                      {plan.subject}
                    </td>
                    <td className="plan_tbody_td plan_td">{plan.email[0]}</td>

                    <td className="plan_tbody_td plan_td">
                      <div
                        onClick={() =>
                          navigate(
                            `/admin/user-activity?tab=13&userid=${plan?.user?._id}`
                          )
                        }
                        className="pointer d-flex plan_tbody_logo align-items-center"
                      >
                        {plan.user ? (
                          <>
                            <img src={plan?.user?.avatar} alt="logo" />
                            <div>
                              <p className="m-0">
                                {plan?.user?.name
                                  ? plan?.user?.name
                                  : `${plan?.user?.firstname} ${plan?.user?.lastname}`}
                              </p>
                              <p className="m-0 mt-8">{`${plan?.user?.email}`}</p>
                            </div>
                          </>
                        ) : (
                          "Not Found"
                        )}
                      </div>
                    </td>
                    <td className="plan_tbody_td plan_td">
                      {returnDate(plan?.createdAt)}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          ) : (
            <h2>No Plans</h2>
          )}
        </div>
        <div className="pagination">
          <Pagination
            count={count ? Math.ceil(count / 20) : 0}
            page={page}
            onChange={(e, v) => setPage(v)}
          />
        </div>
      </div>
      <Modal
        className=" "
        open={open}
        onClose={handleclose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          {currentuser ? (
            <>
              <p className="bold">
                {`${currentuser.name}, ( ${currentuser.firstname} ${currentuser.lastname},${currentuser.type})`}
              </p>
              <p>
                {`Current Plan: ${currentuser.plan?.planName} ${
                  currentuser.plan?.planName !== "Free"
                    ? `, with expiry date ${returnDate(
                        currentuser.plan?.endDate
                      )}`
                    : ""
                } `}
              </p>
              <div>
                <label className="mb-3" htmlFor="typeDropdown">
                  Update Plan
                </label>
                <select
                  id="typeDropdown"
                  value={newplantype}
                  onChange={(e) => setnewplantype(e.target.value)}
                >
                  <option value="">Select New Plan</option>
                  <option value="Free">Free</option>
                  <option value="Freemium">Freemium</option>
                  <option
                    hidden={["corporate", "institute", "member"].includes(
                      currentuser.type
                    )}
                    value="Basic"
                  >
                    Basic
                  </option>
                  <option value="Premium">Premium</option>
                </select>
              </div>
              <div>
                <label className="mb-3" htmlFor="typeDropdown">
                  Plan Duration
                </label>
                <select
                  id="typeDropdown"
                  value={newplanduration}
                  onChange={(e) => setnewplanduration(e.target.value)}
                >
                  <option value="">Extend Plan Duration to</option>
                  <option value="1w">1 Week</option>
                  <option value="1m">1 Month</option>
                  <option value="3m">3 Months</option>
                  <option value="6m">6 Months</option>
                  <option value="1y">1 Year</option>
                </select>
              </div>
              <div>
                <label>
                  <input
                    type="checkbox"
                    checked={sendPlanUpdatedEmail}
                    onChange={(e) => setsendPlanUpdatedEmail(e.target.checked)}
                  />
                  Send Plan Updated Email
                </label>
              </div>
              <br />
              <div>
                <button
                  onClick={() => handleUpdatePlan()}
                  className="gradient_admin_btn"
                >
                  Update Plan
                </button>
              </div>
              {/* <div>
                <label>
                  <input
                    type="checkbox"
                    checked={sendReminders}
                    onChange={(e) => setsendReminders(e.target.checked)}
                  />
                  Send Email on Expiry and Reminders
                </label>
              </div> */}
            </>
          ) : (
            <></>
          )}
        </Box>
      </Modal>
    </>
  );
};

export default EmailLogs;
